<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte nov certifikat:
    </h2>

    <CertificateForm
      @save="save"
      @cancel="cancel"
      :premiseTypes="premiseTypes"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import CertificateForm from '@/components/CertificateForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    CertificateForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    }
  },
  computed: {
    premiseTypes () {
      return objectToArray(this.$store.state.premiseTypes.items)
    }
  },
  methods: {
    ...mapActions('clientsCertificates', ['saveItem']),
    ...mapActions('premiseTypes', { loadPremiseTypes: 'loadItems' }),
    save ({ data }) {
      saveItem({ childCompanyId: this.childCompanyId, item: data }, 'ClientsCertificates', this)
    },
    cancel () {
      this.$router.push({ name: 'ClientsCertificates' })
    }
  },
  created () {
    this.loadPremiseTypes()
      .then(items => { this.asyncDataStatus_fetched() })
  }
}
</script>
